import { inject, observer } from 'mobx-preact'
import Nprogress from 'nprogress'
import React, { Component } from 'react'
import { form } from 'util'
import i18n from 'util/i18n'
import toast from 'util/toast'
import AV from '../av'
import { Input, Link, Submit, SuccessMsg } from './Base'

@inject('store')
@observer
@form
export default class Reset extends Component {
  constructor(props) {
    super(props)
    this.state = {
      wait: false,
      isSend: false,
      interval: 0
    }
  }
  async onSubmit(_e, obj) {
    let { interval } = this.state
    if (interval != 0) return
    Nprogress.start()
    this.setState({wait: true})
    try {
      let success = await AV.User.requestPasswordReset(obj.email)
      if (success) {
        toast(i18n('reset-send'), {type: 'success'})
        this.setState({
          isSend: true,
          interval: 60
        })
        this.interval = setInterval(() => {
          let { interval } = this.state
          if (interval == 0) {
            clearInterval(this.interval)
          } else {
            this.setState({
              interval: interval - 1
            })
          }
        }, 1000)
      }
    } catch (e) {
      toast(e, {type: 'error'})
    } finally {
      this.setState({wait: false})
      Nprogress.done()
    }
  }
  render({store}) {
    let { interval, wait, isSend } = this.state
    let text = i18n('submit')
    if (wait) {
      text = i18n('wait')
    } else if (interval) {
      text = `${interval}`
    }
    let msg = isSend ? <SuccessMsg>{i18n('reset-send')}</SuccessMsg>:''
    return (
      <div>
        <form id="reset" onSubmit={this.onSubmit.bind(this)}>
          <Input type="email" name="email" required placeholder={store.lang=='en' ? 'Enter your email' : '邮箱'}/>
          <Submit value={text} disabled={wait || interval > 0} />
          {msg}
          <div class="login-links">
            <Link onClick={() => store.setStep('signup')}>{store.lang == 'en' ? 'Create an account' : '去注册'}</Link>
          </div>
        </form>
      </div>
    )
  }
}
